module.exports = __webpack_public_path__ + "fonts/Poppins-LightItalic.1eaf3af4.ttf";